var React = require('react');

function LinkArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#fff","strokeLinecap":"square","strokeWidth":"2","transform":"translate(1 2)"},[React.createElement("path",{"d":"m.5 5h16","key":0}),React.createElement("path",{"d":"m13 10 5-5-5-5","key":1})]));
}

LinkArrowWhite.defaultProps = {"height":"14","viewBox":"0 0 21 14","width":"21"};

module.exports = LinkArrowWhite;

LinkArrowWhite.default = LinkArrowWhite;
